import { createContext, useContext, useState, useEffect } from "react";

// 🔄 Dynamically load all images from the player sprites folder
const importAll = (context) => {
	const images = {};
	context.keys().forEach((key) => {
		images[key.replace("./", "")] = context(key);
	});
	return images;
};

// 🎯 Preload all images from these folders
const playerImages = importAll(
	require.context("assets/puzzles/iserba/player", false, /\.(png|jpe?g|svg)$/)
);
const fallingObjectsImages = importAll(
	require.context(
		"assets/puzzles/iserba/fallingObjects",
		false,
		/\.(png|jpe?g|svg)$/
	)
);

const allImages = { ...playerImages, ...fallingObjectsImages }; // Merge all images

const PreloadContext = createContext({ imagesLoaded: false, images: {} });

export const usePreload = () => useContext(PreloadContext);

export const ImagePreloadProvider = ({ children }) => {
	const [imagesLoaded, setImagesLoaded] = useState(false);
	const [loadedImages, setLoadedImages] = useState({});

	useEffect(() => {
		const imageKeys = Object.keys(allImages);
		let loadedCount = 0;

		imageKeys.forEach((key) => {
			const img = new Image();
			img.src = allImages[key].default; // Webpack loads images as modules
			img.onload = () => {
				loadedCount++;
				setLoadedImages((prev) => ({ ...prev, [key]: img.src }));

				if (loadedCount === imageKeys.length) {
					setImagesLoaded(true);
				}
			};
		});
	}, []);

	return (
		<PreloadContext.Provider value={{ imagesLoaded, images: loadedImages }}>
			{children}
		</PreloadContext.Provider>
	);
};
